import { translate } from 'localizations';
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getExportParams } from 'store/calls/calls.slice';

export const useExportTags = (callIds: string[], language: string) => {
	const dispatch = useDispatch();
	const [tags, setTags] = useState<any>(null);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchTags = useCallback(async () => {
		setIsLoading(true);
		setError(null);
		try {
			const params = {
				search_filter_hash: '',
				call_ids: callIds,
			};
			const resultAction = await dispatch(getExportParams(params));
			setTags(resultAction.payload);
		} catch (err) {
			setError(translate('failedToGetTags', language));
			console.error('Error fetching export tags:', err);
		} finally {
			setIsLoading(false);
		}
	}, [callIds, dispatch, language]);

	return { tags, isLoading, error, fetchTags };
};
